import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    agentUsageMonthlyResponseSchema,
    agentUsageQuerySchema,
    agentUsageResponseSchema,
} from "@common/schemas/domains/agentRuns/agent-usage.schema";

const c = initContract();

const organizationPathParams = z.object({
    organizationId: z.string().uuid(),
});

export const agentUsageContract = c.router({
    getOrganizationAgentUsage: {
        method: "GET",
        path: "/agent-usage/organizations/:organizationId",
        pathParams: organizationPathParams,
        query: agentUsageQuerySchema,
        responses: {
            200: agentUsageResponseSchema,
            400: ErrorMessageSchema,
            403: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
    getOrganizationAgentUsageMonthly: {
        method: "GET",
        path: "/agent-usage/organizations/:organizationId/monthly",
        pathParams: organizationPathParams,
        query: agentUsageQuerySchema,
        responses: {
            200: agentUsageMonthlyResponseSchema,
            400: ErrorMessageSchema,
            403: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
});
